import { component } from "preact";
import { css } from "emotion";

const H2 = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  breakpoint = 600,
  maxWidth,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  children
}) => {
  const styleObj = {
    fontWeight: 600,
    fontSize: 26,
    maxWidth: maxWidth ? maxWidth : "none",
    marginLeft: maxWidth ? "auto" : 0,
    marginRight: maxWidth ? "auto" : 0,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom
  };
  styleObj[`@media(max-width: ${breakpoint}px)`] = {
    fontSize: 18,
    marginTop: marginTopMobile,
    marginBottom: marginBottomMobile
  };
  const style = css(styleObj);

  return <h2 className={style}>{children}</h2>;
};

export default H2;
